<template>
  <div
    class="d-flex pa-2 full-width overflow-hidden flex-md-row"
    v-on="$listeners"
  >
    <v-avatar :color="typeMeta.avatar" size="60">
      <v-img
        v-if="item.image_url"
        :src="image_url"
        :lazy-src="image_url"
        :aspect-ratio="1"
        min-width="100"
      >
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-icon :color="typeMeta.color" size="32">{{ typeMeta.icon }}</v-icon>
          </v-row>
        </template>
      </v-img>
      <v-icon v-else :color="typeMeta.color" size="36">{{ typeMeta.icon }}</v-icon>
    </v-avatar>
    <div
      class="pl-4 pb-2 pr-4 flex-grow-1 d-flex flex-column full-width overflow-hidden"
    >
      <div
        class="font-weight-bold full-width"
        :title="item.name"
        style="font-size:20px"
      >
        {{ item.name }}
      </div>
      <div class="d-flex">
        <v-chip
          small
          class="mt-1"
          :color="typeMeta.color"
          label
          outlined
        >
          {{ typeMeta.label }}
        </v-chip>
      </div>
      <div
        class="pt-2 pb-1 d-flex align-center full-width"
        :title="item.updated_at | calcDate"
      >
        <span class="text-truncate">
          {{ $t('workspace.modified') }}
          <strong class="ng-binding">{{ item.updated_at | calcDate }}</strong>
        </span>
      </div>
      <div class="mt-auto">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { getUUIDv4 } from '@utils'
import { getDatastoreTypeMeta } from '@constant'
export default {
  props: {
    workspace: { type: Object, default: () => ({}) },
    value: { type: Object, require: true, default: () => ({}) },
  },
  data: () => ({
    key: '',
  }),
  mounted() {
    this.key = getUUIDv4()
  },
  computed: {
    item() {
      return this.value
    },
    typeMeta() {
      return getDatastoreTypeMeta(this.value)
    },
    image_url() {
      return `${this.item.image_url}?key=${this.key}`
    },
  },
}
</script>

<style scoped></style>
